import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

/**
 * Backend: FetchRequestType => nameof(sub_dashboard_fetch_request)
 * Response: sub_dashboard_response_view
 *   abortion_government, abortion_private,
 *   miscarriage_government, miscarriage_private
 */
export class SubDashboardFetchRequest {
  public static readonly FetchRequestType: string = "sub_dashboard_fetch_request";

  // Hierarchy (same pattern as DashboardsFetchRequest)
  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_ids: number[] = [];
  af_ids: number[] = [];
  asha_employee_record_ids: number[] = [];
  asha_post_ids: number[] = [];

  af_employee_record_ids: number[] = [];
  af_post_ids: number[] = [];

  bcm_employee_record_ids: number[] = [];
  bcm_post_ids: number[] = [];

  dcm_employee_record_ids: number[] = [];
  dcm_post_ids: number[] = [];

  // Period
  report_filter_type: number = 0;
  quarterly_year_type: number = 0;
  half_year_type: number = 0;
  month: number = 0;
  financial_year_ids: number[] = [];
  request_date_time: string = '';

  // The 4 keys
  drill_down_request_type: number = 0;   // e.g. 14000
  drill_down_sub_type: number = 0;       // e.g. 14001, 0 if none
  sub_dashboard_filter_by: number = 0;   // level-1 card, 0 if none
  sub_dashboard_child_filter_by: number = 0; // level-2 card, 0 if none

  login_user_id: number = 0;

  public MergeIntoTransportData = (td: TransportData) => {
    const coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      SubDashboardFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    const td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);
    return td;
  };
}